// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vert-showcase-services .ant-carousel .slick-list .slick-slide {
  pointer-events: initial !important;
}
.vert-showcase-services .ant-carousel .slick-list .slick-slide div {
  pointer-events: initial !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/ShowcaseServices/index.less"],"names":[],"mappings":"AAAA;EACE,kCAAA;AACF;AAAE;EACE,kCAAA;AAEJ","sourcesContent":[".vert-showcase-services .ant-carousel .slick-list .slick-slide {\n  pointer-events: initial !important;\n  & div {\n    pointer-events: initial !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
